<template>
  <div id="app">
    <!-- <el-scrollbar ref="scroll" style="height: 100vh;"> -->
      <router-view :key="$route.fullPath"></router-view>
      <!-- <el-backtop target=".el-scrollbar__wrap"  :bottom = "100"
          :right="40"></el-backtop> -->
    <!-- </el-scrollbar> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
  },
  methods:{
  }
}
</script>

<style lang="scss">
 #app{
      position: relative;
      background: #F7F9FA;
      /* min-width: 1200px; */
      /*min-width: 1920px;*/
    }

/* .el-scrollbar__wrap {
  
    overflow-x: hidden !important;
}
.el-select-dropdown .el-scrollbar .el-scrollbar__wrap
{
  overflow-x: hidden !important;
overflow: scroll!important;
overflow: auto;
}
.el-scrollbar__bar .el-scrollbar__thumb {
    border-radius: 3px;
  }
  .progressInfoList .el-scrollbar__bar.is-vertical{
    z-index: 3;
  } */

  html, body, div, ul, li, h1, h2, h3, h4, h5, h6, p, dl, dt, dd, ol, form, input, textarea, th, td, select {
    margin: 0;
    padding: 0;
    font-family: "PingFang SC";
  }
  *{box-sizing: border-box;}
  html, body {
    min-height: 100%;
  }

  body {
    font-family: "PingFang SC,Microsoft YaHei";
    font-size:14px;
    /* color:#333; */
  }
  h1, h2, h3, h4, h5, h6{font-weight:normal;}
  ul,ol {
    list-style: none;
  }

  img {
    border: none;
    vertical-align: middle;
  }

  a {
    text-decoration: none;
    /* color: #232323; */
  }
  a:link {color:#000;}		/* 未被访问的链接 */
a:visited {color:#000;}	/* 已被访问的链接 */
a:hover {color:#000;}	/* 鼠标指针移动到链接上 */
a:active {color:#000;}	/* 正在被点击的链接 */

  table {
    border-collapse: collapse;
    table-layout: fixed;
  }

  input, textarea {
    outline: none;
    /* border: none; */
  }

  textarea {
    resize: none;
    overflow: auto;
  }

  .clearfix {
    zoom: 1;
  }

  .clearfix:after {
    content: ".";
    width: 0;
    height: 0;
    visibility: hidden;
    display: block;
    clear: both;
    overflow:hidden;
  }

  .qjm_proname{
      background-image: linear-gradient(left, #147B96, #E6D205 25%, #147B96 50%, #E6D205 75%, #147B96);
      -webkit-text-fill-color: transparent;
      -webkit-background-clip: text;
      background-size: 200% 100%;
      animation: prodTxt 2s infinite linear;
    }
    @keyframes prodTxt {
    to{
        background-position: 0 0;
    }
    from{
        background-position: -100% 0;
    }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue